module.exports = __webpack_public_path__ + "static/media/Fracassets.450ea20b.png";